import "./header.css"
import logo from "../../assets/logo.svg"
import Dropdown from 'react-bootstrap/Dropdown';
import {useTranslation} from 'react-i18next';
import {useState} from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import {Link} from "react-router-dom";

function Header() {
    const [selectedLanguage, setSelectedLanguage] = useState('English')
    const {i18n} = useTranslation();
    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);

        if (lng === 'en') {
            setSelectedLanguage("English")
        } else if (lng === 'fr') {
            setSelectedLanguage("Français")
        } else if (lng === 'aue') {
            setSelectedLanguage("لعربية")
        } else if (lng === 'ch') {
            setSelectedLanguage("中文")
        } else if (lng === 'jp') {
            setSelectedLanguage("日本語")
        } else if (lng === 'no') {
            setSelectedLanguage("Español")
        } else if (lng === 'ru') {
            setSelectedLanguage("Русский")
        }
    };

    return (
        <div className="header">
            <>
                {['xxl'].map((expand) => (
                    <Navbar key={expand} expand={expand}>
                        <Container fluid>
                            <Navbar.Brand href="#">
                                <a href="/"><img className="header_logo" src={logo} alt=""/></a>
                            </Navbar.Brand>
                            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`}/>
                            <Navbar.Offcanvas
                                id={`offcanvasNavbar-expand-${expand}`}
                                aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                                placement="end"
                            >
                                <Offcanvas.Header closeButton>
                                </Offcanvas.Header>

                                <Offcanvas.Body>
                                    <Nav className="justify-content-end flex-grow-1 gap-4">
                                        <div className="header_items">
                                            <Link to="/about-us" style={{textDecoration: "none", color: "white"}}>About Us</Link>
                                        </div>
                                        <div className="header_items">
                                            <span><a style={{textDecoration: "none", color: "white"}}
                                                     href="https://www.choicetrade.com/contact-us.php" target="_blank" rel="noreferrer">Contact Us</a></span>
                                        </div>
                                    </Nav>

                                    <div className="header_lang_item">
                                        <Dropdown>
                                            <Dropdown.Toggle id="dropdown-basic">
                                                {selectedLanguage}
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item href=""
                                                               onClick={() => changeLanguage('en')}>English</Dropdown.Item>
                                                <Dropdown.Item href=""
                                                               onClick={() => changeLanguage('aue')}>لعربية</Dropdown.Item>
                                                <Dropdown.Item href=""
                                                               onClick={() => changeLanguage('no')}>Español</Dropdown.Item>
                                                <Dropdown.Item href=""
                                                               onClick={() => changeLanguage('fr')}>Français</Dropdown.Item>
                                                <Dropdown.Item href=""
                                                               onClick={() => changeLanguage('ru')}>Русский</Dropdown.Item>
                                                <Dropdown.Item href=""
                                                               onClick={() => changeLanguage('ch')}>中文</Dropdown.Item>
                                                <Dropdown.Item href=""
                                                               onClick={() => changeLanguage('jp')}>日本語</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </Offcanvas.Body>
                            </Navbar.Offcanvas>
                        </Container>
                    </Navbar>
                ))}
            </>
        </div>
    )
}

export default Header;